module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/public-sciences-3-37dd1395cbdbc49d57ce98f3923e23e0.png";